// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3c5Q5","content":"styles_content__1f_zU","checkbox":"styles_checkbox__wvKMi","checkboxLabel":"styles_checkboxLabel__35CXe"};